function getText(p) {
  const item = Object.assign({}, p);
  let css = "";
  let command = item.command.name;

  if (item.command.name === "install") css = "is-success";
  if (item.command.name === "uninstall") css = "is-danger";
  if (item.command.name === "upgrade") {
    css = "is-info";
    command = "upgrad";
  }

  return `<span class='tags has-addons'>    
    <span class='tag is-rounded is-default is-light'>
     ${item.package.name} - ${item.version.version}
    </span>
    <span class='tag is-rounded is-capitalized is-light ${css}'>
    ${command}ing
    </span>
  </span>`;
}

export default {
  namespaced: true,
  state: {
    package: null,
    text: ""
  },
  mutations: {
    setPackage(state, p) {
      state.package = p;

      if (p && p.command && p.command.status === "working") {
        state.text = getText(p);
      } else state.text = "";
    },
    setText(state, text) {
      state.text = text;
    },
    clear(state) {
      state.workingPackage = null;
    }
  },
  actions: {
    checkAndSetPackage({ state, commit, rootState }, p) {
      if (
        !state.package ||
        p.command.status === "working" ||
        (rootState.settings.user.profile.infobar &&
          rootState.settings.user.profile.infobar.workingStatus &&
          state.package.packageHash == p.package.packageHash &&
          p.source.uid === state.package.source.uid)
      ) {
        if (p.command.status === "working") commit("setPackage", p);
        else commit("setPackage", null);
      }
    }
  }
};
